/**
 * How much padding should be on either side of the calendar picker,
 * in pixels
 */
export const CALENDAR_PADDING = 24;
